(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() { super(); }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }
    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }
    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }
    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timba-knowledge-intro"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('timba-knowledge-slider')) {
  customElements.define('timba-knowledge-slider', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.index = 0;
      this.slides = [...this.querySelectorAll('.tk-slide')];
      this.dots = [...this.querySelectorAll('[data-tk-dot]')];
      this.stage = this.querySelector('.tk-slider-stage');
      this.pauseButton = this.querySelector('[data-tk-pause]');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.inView = false;
      this.hovered = false;
      this.focused = false;
      this.abort = new AbortController();
      const on = (target, event, fn) => target.addEventListener(event, fn, {signal: this.abort.signal});
      this.querySelector('.tk-slider-controls').hidden = false;
      on(this.querySelector('[data-tk-next]'), 'click', () => this.show(this.index + 1, true));
      on(this.querySelector('[data-tk-previous]'), 'click', () => this.show(this.index - 1, true));
      this.dots.forEach((dot, i) => on(dot, 'click', () => this.show(i, true)));
      on(this.pauseButton, 'click', () => { this.paused = !this.paused; this.sync(); });
      on(this, 'mouseenter', () => { this.hovered = true; this.sync(); });
      on(this, 'mouseleave', () => { this.hovered = false; this.sync(); });
      on(this, 'focusin', () => { this.focused = true; this.sync(); });
      on(this, 'focusout', (e) => { this.focused = this.contains(e.relatedTarget); this.sync(); });
      on(this, 'keydown', (e) => {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault(); this.show(this.index + (e.key === 'ArrowRight' ? 1 : -1), true);
        }
      });
      on(document, 'visibilitychange', () => this.sync());
      on(this.motion, 'change', () => { if (this.motion.matches) this.paused = true; this.sync(); });
      this.observer = new IntersectionObserver((entries) => {
        this.inView = entries[0].isIntersecting; this.sync();
      }, {threshold: 0.35});
      this.observer.observe(this);
      this.sync();
    }
    show(index, manual = false) {
      if (manual) this.paused = true;
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
      this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === this.index)));
      this.sync();
    }
    sync() {
      clearTimeout(this.timer);
      this.pauseButton.textContent = this.dataset[this.paused ? 'play' : 'pause'];
      const running = !this.paused && !this.motion.matches && this.inView && !this.hovered && !this.focused && !document.hidden;
      this.stage.setAttribute('aria-live', running ? 'off' : 'polite');
      if (running) this.timer = setTimeout(() => this.show(this.index + 1), 8000);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.abort?.abort();
      this.observer?.disconnect();
      this.ready = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
